<template>
  <star-condition-layout
    ref="starCondition"
    :onSearch="handleSearch"
    :onReset="reset"
    :loading="loading"
  >
    <star-condition-cell label="站点类型">
      <a-select v-model="searchCondition.spiderClassId" :style="{ width: '100%' }">
        <a-select-option v-for="cls in classList" :value="cls.spiderClassId">
          {{ cls.spiderClassName }}
        </a-select-option>
      </a-select>
    </star-condition-cell>

    <star-condition-cell label="站点ID">
      <a-input v-model="searchCondition.spiderId" style="width: 100%" allowClear> </a-input>
    </star-condition-cell>

    <star-condition-cell label="站点名称">
      <a-input v-model="searchCondition.spiderName" style="width: 100%" allowClear> </a-input>
    </star-condition-cell>

    <star-condition-cell label="审批状态">
      <a-select v-model="searchCondition.examineStatus" :style="{ width: '100%' }" allowClear>
        <a-select-option :value="0">待审核</a-select-option>
        <a-select-option :value="1">已通过</a-select-option>
        <a-select-option :value="2">已驳回</a-select-option>
        <a-select-option :value="3">已删除</a-select-option>
      </a-select>
    </star-condition-cell>

    <star-condition-cell label="申请时间" class="large">
      <a-range-picker :style="{ width: '100%' }" v-model="searchCondition.timeRange" />
    </star-condition-cell>

    <star-condition-cell label="审核时间" class="large">
      <a-range-picker :style="{ width: '100%' }" v-model="searchCondition.examineTimeRange" />
    </star-condition-cell>
  </star-condition-layout>
</template>

<script>
import moment from 'moment'
import CountrySelect from '@/components/CountrySelect/'
import _ from 'lodash'

export default {
  components: { CountrySelect },
  props: {
    onSearch: {
      type: Function,
      required: true
    },
    loading: Boolean,
    classList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      searchCondition: {
        spiderClassId: undefined,
        spiderId: undefined,
        spiderName: undefined,
        examineStatus: undefined,
        timeRange: null,
        examineTimeRange: null
      }
    }
  },
  created(){
      this.searchCondition['spiderId'] = this.$route.query.spiderId
  },

  watch: {
    classList() {
      if (this.searchCondition.spiderClassId) return

      const newsId = this.classList.find((d) => d.type === 'news')?.spiderClassId
      const queryClassId = this.classList.find((d) => d.type === this.$route.query.type)
        ?.spiderClassId
      this.searchCondition.spiderClassId = queryClassId ? queryClassId : newsId

      this.handleSearch()
    }
  },

  methods: {
    reset() {
      this.searchCondition = {
        spiderClassId: this.searchCondition.spiderClassId,
        spiderId: '',
        spiderName: '',
        examineStatus: undefined,
        timeRange: null,
        examineTimeRange: null
      }
      this.handleSearch()
    },

    getFormatTime(d, isFirst) {
      if (!d) {
        return undefined
      }
      const hms = isFirst ? '00:00:00' : '23:59:59'
      return moment(d).format(`YYYY-MM-DD ${hms}`)
    },

    handleSearch() {
      const condition = {
        ...this.searchCondition,
        applyStartTime: this.getFormatTime(this.searchCondition.timeRange?.[0], true),
        applyEndTime: this.getFormatTime(this.searchCondition.timeRange?.[1], false),
        examineStartTime: this.getFormatTime(this.searchCondition.examineTimeRange?.[0], true),
        examineEndTime: this.getFormatTime(this.searchCondition.examineTimeRange?.[1], false)
      }
      this.onSearch(_.omitBy(condition, _.isUndefined))
    }
  }
}
</script>
